/* eslint react/no-danger: 0 */

import PropTypes from 'prop-types';
import React from 'react';

import '../global-sass/main.scss';

const renderSpecDescription = (prefs, specIds, specObj) =>
	specIds.map((id) => {
		let specDescription = (specObj[id] && specObj[id].description) || '';
		let specDetail = (specObj[id] && specObj[id].detail) || '';
		const specDisclaimers = (specObj[id] && specObj[id].disclaimers) || '';
		const specTerms = (specObj[id] && specObj[id].terms) || [];
		const specItemDescriptionClasses = ['spec-item-description'];

		const {
			disclaimerFontSize = 'xxsmall',
			isSpecDescriptionMuted = 'true'
		} = prefs;

		if (Array.isArray(specTerms) && specTerms.length) {
			if (specTerms.length === 1) {
				[specDetail] = specTerms;
			} else {
				// Create unordered list if more than one term exists.
				specDetail = '<ul>';
				specTerms.map((term) => {
					specDetail += `<li>${term}</li>`;

					return specDetail;
				});
				specDetail += '</ul>';
			}
		}

		if (specDetail) {
			specDescription = specDescription.concat(': ');

			// checking against 'false' in case pref doesn't exist and is not false
			// because 'true' is the default state
			if (isSpecDescriptionMuted !== 'false') {
				specItemDescriptionClasses.push('text-muted');
			}
		}

		return (
			<li key={id} className="spec-item">
				<span
					className={specItemDescriptionClasses.join(' ')}
					dangerouslySetInnerHTML={{
						__html: specDescription
					}}
				/>
				{!!specDetail && (
					<span
						className="spec-item-detail"
						dangerouslySetInnerHTML={{
							__html: specDetail
						}}
					/>
				)}
				{!!specDisclaimers && (
					<div
						className={`spec-item-disclaimers text-muted ddc-font-size-${disclaimerFontSize}`}
						dangerouslySetInnerHTML={{
							__html: specDisclaimers
						}}
					/>
				)}
			</li>
		);
	});

const SpecDescription = ({
	prefs,
	specIds,
	specification,
	isFullWidthLayout
}) => {
	const specObj = specification.reduce(
		(obj, itm) => ({
			...obj,
			[itm.id]: itm.spec
		}),
		{}
	);

	return (
		<React.Fragment>
			<ul
				className={`spec-list list-unstyled list-spaced line-height-condensed mt-4 ml-2 pl-5 ${
					isFullWidthLayout ? 'detail-specs-col-full-width' : ''
				}`}
			>
				{renderSpecDescription(prefs, specIds, specObj)}
			</ul>
		</React.Fragment>
	);
};

SpecDescription.propTypes = {
	prefs: PropTypes.shape({
		disclaimerFontSize: PropTypes.string,
		isSpecDescriptionMuted: PropTypes.string
	}),
	specIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	specification: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			spec: PropTypes.shape({}).isRequired
		})
	).isRequired,
	isFullWidthLayout: PropTypes.bool
};

SpecDescription.defaultProps = {
	prefs: {
		disclaimerFontSize: 'xxsmall',
		isSpecDescriptionMuted: 'true'
	}
};

export default SpecDescription;
